var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoAnillosBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    xmlSpace: "preserve",
    style: {
      width: 150,
      margin: "15px auto 0px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M60.1,113.8c-14.8,0-26.8-12-26.8-26.8s12-26.8,26.8-26.8s26.8,12,26.8,26.8S74.9,113.8,60.1,113.8z  M60.1,63.8C47.3,63.8,37,74.2,37,87s10.4,23.1,23.1,23.1S83.2,99.7,83.2,87C83.2,74.2,72.8,63.8,60.1,63.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M90.3,113.8c-13.2,0-24-10.8-24-24 s10.8-24,24-24s24,10.8,24,24S103.6,113.8,90.3,113.8z M90.3,69.4C79.1,69.4,70,78.6,70,89.8s9.1,20.3,20.3,20.3 s20.3-9.1,20.3-20.3S101.5,69.4,90.3,69.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.1,62.5c-0.3,0-0.6-0.1-0.9-0.3 L48.1,54c-0.5-0.4-0.7-1.1-0.5-1.7l2.2-6.3c0.2-0.6,0.8-1,1.4-1h17.6c0.6,0,1.2,0.4,1.4,1l2.4,6.3c0.2,0.6,0,1.3-0.5,1.7L61,62.2 C60.7,62.4,60.4,62.5,60.1,62.5z M50.8,52.3l9.3,6.8l9.3-6.8L67.8,48H52.3L50.8,52.3z",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044860661441330345490000014129596467374500749_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4642,
    y1: 19.0811,
    x2: 143.4642,
    y2: 86.0811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02112336,
    style: {
      stopColor: "rgb(237, 214, 130)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04863281,
    style: {
      stopColor: "rgb(217, 183, 91)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07576038,
    style: {
      stopColor: "rgb(201, 159, 59)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    style: {
      stopColor: "rgb(190, 142, 37)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1271,
    style: {
      stopColor: "rgb(183, 132, 24)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1495,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2295,
    style: {
      stopColor: "rgb(197, 151, 44)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4075,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "rgb(222, 185, 83)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6752,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7715,
    style: {
      stopColor: "rgb(198, 152, 46)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "rgb(183, 131, 23)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9066,
    style: {
      stopColor: "rgb(189, 141, 36)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "rgb(200, 157, 56)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "rgb(214, 180, 86)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    style: {
      stopColor: "rgb(233, 208, 123)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,31.9c-0.2-0.2-0.6-0.4-0.9-0.4 c-0.4,0-0.7,0.1-0.9,0.4l-5.9,5.9c-0.2,0.2-0.4,0.6-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9c0.5,0.5,1.4,0.5,1.9,0l5.9-5.9 C75.7,33.3,75.7,32.4,75.2,31.9z",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011753766205132598970000005116329192892452239_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.4226,
    y1: 22.0064,
    x2: 141.4226,
    y2: 89.0064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02112336,
    style: {
      stopColor: "rgb(237, 214, 130)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04863281,
    style: {
      stopColor: "rgb(217, 183, 91)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07576038,
    style: {
      stopColor: "rgb(201, 159, 59)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    style: {
      stopColor: "rgb(190, 142, 37)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1271,
    style: {
      stopColor: "rgb(183, 132, 24)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1495,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2295,
    style: {
      stopColor: "rgb(197, 151, 44)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4075,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "rgb(222, 185, 83)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6752,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7715,
    style: {
      stopColor: "rgb(198, 152, 46)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "rgb(183, 131, 23)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9066,
    style: {
      stopColor: "rgb(189, 141, 36)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "rgb(200, 157, 56)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "rgb(214, 180, 86)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    style: {
      stopColor: "rgb(233, 208, 123)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,28.1c0-0.7-0.8-1.3-1.5-1.3 s-1.5,0.6-1.5,1.3v8.3c0,0.7,0.8,1.3,1.5,1.3s1.5-0.6,1.5-1.3V28.1z",
    style: {
      fill: "#2b2b2b"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021095352563923972160000018388661688502742661_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.071,
    y1: 29.6744,
    x2: 136.071,
    y2: 96.6744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02112336,
    style: {
      stopColor: "rgb(237, 214, 130)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04863281,
    style: {
      stopColor: "rgb(217, 183, 91)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07576038,
    style: {
      stopColor: "rgb(201, 159, 59)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    style: {
      stopColor: "rgb(190, 142, 37)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1271,
    style: {
      stopColor: "rgb(183, 132, 24)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1495,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2295,
    style: {
      stopColor: "rgb(197, 151, 44)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4075,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "rgb(222, 185, 83)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5803,
    style: {
      stopColor: "rgb(219, 181, 79)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6752,
    style: {
      stopColor: "rgb(211, 170, 66)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7715,
    style: {
      stopColor: "rgb(198, 152, 46)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    style: {
      stopColor: "rgb(181, 128, 19)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "rgb(183, 131, 23)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9066,
    style: {
      stopColor: "rgb(189, 141, 36)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "rgb(200, 157, 56)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "rgb(214, 180, 86)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    style: {
      stopColor: "rgb(233, 208, 123)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255, 242, 166)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,37.8l-5.9-5.9 c-0.2-0.2-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.5,0.5-0.5,1.3,0,1.9l5.9,5.9c0.5,0.5,1.4,0.5,1.9,0c0.2-0.2,0.4-0.6,0.4-0.9 C53.1,38.4,52.9,38,52.7,37.8z",
    style: {
      fill: "#2b2b2b"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "60.1,60.6 52.4,47.3 55,45.8  60.1,54.6 64.6,46.6 67.2,48.1  ",
    style: {
      fill: "#2b2b2b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAnillosBlack);
export default __webpack_public_path__ + "static/media/icono-anillos-black.6bb628625b53735654370ba345542bd0.svg";
export { ForwardRef as ReactComponent };